import { useState } from "react";
import { CheckIcon, CloseIcon } from "../components/icons";
import { forgotPasswordSendOtp, forgotPasswordVerifyOtp } from "../api/authApi";
import { isApiSuccess } from "../utils/apiResponse";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function ForgotPasswordPage({ onClose, onFlash }) {
  const [email, setEmail] = useState();
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");
  const emailOk = EMAIL_RE.test(email);
  const otpOk = otp.length === 6;

  const submit = async () => {
    setApiError("");
    if (!otpSent) {
      if (!emailOk) {
        setSubmitted(true);
        return;
      }
      setSubmitting(true);
      try {
        const { data } = await forgotPasswordSendOtp(email);
        if (!isApiSuccess(data)) {
          setApiError(data?.message || "Could not send OTP");
          return;
        }
        setOtpSent(true);
        setSubmitted(false);
        onFlash("OTP sent to " + email);
      } catch (err) {
        setApiError(err.response?.data?.message || "Could not send OTP");
      } finally {
        setSubmitting(false);
      }
      return;
    }
    if (!otpOk) {
      setSubmitted(true);
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await forgotPasswordVerifyOtp(email, otp);
      if (!isApiSuccess(data)) {
        setApiError(data?.message || "Could not verify OTP");
        return;
      }
      onFlash("Verified — set a new password from Profile");
      onClose();
    } catch (err) {
      setApiError(err.response?.data?.message || "Could not verify OTP");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-col">
        <div className="auth-card auth-card--standalone">
          <div className="auth-card__header">
            <button type="button" className="auth-card__header-btn" aria-label="Close" onClick={onClose}>
              <CloseIcon size={20} />
            </button>
            <h1>Forgot Password</h1>
          </div>
          {apiError && <div className="auth-error-banner">{apiError}</div>}
          <p style={{ font: "400 15px/24px 'Poppins'", color: "var(--ink-900)", margin: "0 0 26px" }}>
            We will send an OTP to your register email for login and then you will be able to create a new password from Profile page
          </p>
          <div className="email-field">
            <span className="email-field__label">Email</span>
            <input
              className={"email-field__input" + (submitted && !emailOk ? " input-invalid" : "")}
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailOk && (
              <span className="email-field__check">
                <CheckIcon size={18} width={2.4} />
              </span>
            )}
            {submitted && !emailOk && <span className="field-error">Enter a valid email address</span>}
          </div>
          {otpSent && (
            <div className="otp-field">
              <input
                className={submitted && !otpOk ? "input-invalid" : ""}
                inputMode="numeric"
                placeholder="Enter OTP to Verify"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
              />
              <span className="otp-field__timer">00:28</span>
              {submitted && !otpOk && <span className="field-error">Enter the 6-digit OTP</span>}
            </div>
          )}
          <button type="button" className="btn-primary" onClick={submit} disabled={submitting}>
            {submitting ? (otpSent ? "Verifying…" : "Sending…") : otpSent ? "Verify" : "Get OTP"}
          </button>
        </div>
      </div>
    </div>
  );
}
